// extracted by mini-css-extract-plugin
module.exports = {"container":"BoxBody_container__2decg"};